import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function Pricing() {
  const tiers = [{
    name: 'Launchpad',
    price: '3,200',
    target: 'For early-stage SaaS',
    features: ['8 comprehensive articles/mo', 'Basic content strategy', 'Technical SEO optimization', 'Monthly performance reporting'],
    highlighted: false
  }, {
    name: 'Ascent',
    price: '6,800',
    target: 'For scaling companies',
    features: ['16 comprehensive articles/mo', 'Full strategy architecture', 'Thought leadership pieces', 'Multi-channel distribution', 'Revenue attribution setup'],
    highlighted: true
  }, {
    name: 'Apex',
    price: '12,500',
    target: 'Enterprise',
    features: ['Unlimited content production', 'Dedicated content strategist', 'Full attribution framework', 'Executive ghostwriting', 'Custom data reports & whitepapers'],
    highlighted: false
  }];
  return <section id="pricing" className="py-24 bg-white" data-id="element-112">
      <div className="container mx-auto px-6 max-w-7xl" data-id="element-113">
        <div className="text-center mb-20" data-id="element-114">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-heading font-bold text-navy-900 mb-6" data-id="element-115">
            Transparent investment.
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-slate-600 max-w-2xl mx-auto text-lg" data-id="element-116">
            Predictable pricing for predictable pipeline growth.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto items-center" data-id="element-117">
          {tiers.map((tier, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`relative border ${tier.highlighted ? 'border-navy-900 bg-navy-900 text-white shadow-2xl py-14 px-10' : 'border-slate-200 bg-white text-navy-900 py-10 px-8'}`} data-id="element-118">
              {tier.highlighted && <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white text-navy-900 text-xs font-bold uppercase tracking-widest py-1 px-4 border border-navy-900" data-id="element-119">
                  Most Popular
                </div>}

              <div className="mb-8" data-id="element-120">
                <h3 className={`text-2xl font-heading font-bold mb-2 ${tier.highlighted ? 'text-white' : 'text-navy-900'}`} data-id="element-121">
                  {tier.name}
                </h3>
                <p className={`text-sm ${tier.highlighted ? 'text-navy-300' : 'text-slate-500'}`} data-id="element-122">
                  {tier.target}
                </p>
              </div>

              <div className="mb-8 pb-8 border-b border-opacity-20 border-current" data-id="element-123">
                <div className="flex items-baseline gap-1" data-id="element-124">
                  <span className="text-2xl font-medium" data-id="element-125">€</span>
                  <span className="text-5xl font-heading font-bold tracking-tight" data-id="element-126">
                    {tier.price}
                  </span>
                  <span className={`text-sm ${tier.highlighted ? 'text-navy-300' : 'text-slate-500'}`} data-id="element-127">
                    /mo
                  </span>
                </div>
              </div>

              <ul className="space-y-4 mb-10" data-id="element-128">
                {tier.features.map((feature, fIndex) => <li key={fIndex} className="flex items-start gap-3" data-id="element-129">
                    <Check size={18} className={`mt-0.5 flex-shrink-0 ${tier.highlighted ? 'text-navy-300' : 'text-navy-900'}`} data-id="element-130" />
                    <span className={`text-sm ${tier.highlighted ? 'text-slate-300' : 'text-slate-600'}`} data-id="element-131">
                      {feature}
                    </span>
                  </li>)}
              </ul>

              <a href="#contact" className={`block w-full text-center py-4 text-sm font-bold transition-colors ${tier.highlighted ? 'bg-white text-navy-900 hover:bg-slate-100' : 'bg-navy-900 text-white hover:bg-navy-800'}`} data-id="element-132">
                Get Started
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}